/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type SurveyQuestionType = (typeof SurveyQuestionType)[keyof typeof SurveyQuestionType]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SurveyQuestionType = {
  SINGLE: 'SINGLE',
  MULTI: 'MULTI',
  FREE: 'FREE',
} as const
